export const DOCUMENT_TYPE_PRODUCT_FRONTPAGE = 'productFrontpage';
